<div class="overflow-x-auto">
  <table class="min-w-full divide-y divide-gray-200">
    <thead class="bg-gray-100">
      @for (headerGroup of table.getHeaderGroups(); track headerGroup.id) {
      <tr>
        @for (header of headerGroup.headers; track header.id) {
        <th
          [attr.colSpan]="header.colSpan"
          class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
        >
          @if (!header.isPlaceholder) {
          <ng-container
            *flexRender="header.column.columnDef.header; props: header.getContext(); let headerCell"
          >
            <div [innerHTML]="headerCell"></div>
          </ng-container>

          }
        </th>
        }
      </tr>
      }
    </thead>
    <tbody class="bg-white divide-y divide-gray-200">
      @if (table.getRowModel().rows.length) { @for (row of table.getRowModel().rows; track row.id) {
      <tr>
        @for (cell of row.getVisibleCells(); track cell.id) {
        <td class="px-6 py-4 whitespace-nowrap">
          <ng-container
            *flexRender="cell.column.columnDef.cell; props: cell.getContext(); let renderCell"
          >
            <div [innerHTML]="renderCell"></div>
          </ng-container>
        </td>
        }
      </tr>
      } }@else {
      <div class="bg-gray-100 w-full flex justify-center">Nenhum resultado!</div>
      }
    </tbody>
  </table>
</div>
